import { useContext } from "react";

import { AuthenticationContext } from "../../contexts";

export const useAuthentication = () => {
	return useContext(AuthenticationContext);
};
